import PropTypes from 'prop-types';
import { CODE_EDITOR_PROP_TYPES } from '../../code-editor/types';

const { value, defaultValue, onValidate, ...restPropTypes } = CODE_EDITOR_PROP_TYPES;

export const CODE_EDITOR_FIELD_PROP_TYPES = {
  ...restPropTypes,
  name: PropTypes.string.isRequired,
  control: PropTypes.shape({}).isRequired,
  rules: PropTypes.shape({}),
  onEditorError: PropTypes.func,
};
